<template>
    <portal to="modals">
        <Modal
            v-if="modelValue"
            :title="$t(title)"
            name="builds-dialog"
            modal-class="books-builds__dialog"
            @close="close"
        >
            <template #content>
                <slot />
            </template>
            <template #bottom>
                <slot name="actions" :close="close" />
            </template>
        </Modal>
    </portal>
</template>
<script>
import { Modal } from '@speechki-frontend/shared/ui/modals';

export default {
    components: {
        Modal
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: null
        }
    },
    emits: ['update:modelValue', 'open', 'close'],
    methods: {
        open() {
            this.$emit('update:modelValue', true);
            this.$emit('open');
        },
        close() {
            this.$emit('update:modelValue', false);
            this.$emit('close');
        }
    }
};
</script>
